import Aos from "aos";
import React from "react";
import { useEffect } from "react";
import { Card, Col, Container, Row } from "react-bootstrap";
import serivce1 from "../../../assets/images/service/service-img-1.png";
import serivce2 from "../../../assets/images/service/service-img-2.png";
import serivce3 from "../../../assets/images/service/service-img-3.png";
import serivce4 from "../../../assets/images/service/service-img-4.png";

const ServiceSection = () => {
  useEffect(() => {
    Aos.init({ duration: 2000 });
  }, []);
  return (
    <div>
      <div id="service" className="dot-shape">
        <h2 className="text-center">Sevices</h2>
        <p className="text-center">What I'll do for you</p>
      </div>
      <Container className="services">
        <Row xs={1} md={2} className="g-4">
          <Col data-aos="fade-up">
            <Card className="service-card service-1">
              <Row xs={1} md={2}>
                <Col>
                  <h3>Agency Website</h3>
                  <p>
                    I'll build your Agency website professionally. I have done
                    some local projects like these type of website.
                  </p>
                </Col>
                <Col>
                  <img className="img-fluid" src={serivce1} alt="" />
                </Col>
              </Row>
            </Card>
          </Col>
          <Col data-aos="fade-up">
            <Card className="service-card service-2">
              <Row xs={1} md={2}>
                <Col>
                  <h3>E-Commerce site</h3>
                  <p>
                    Product management on e-commerce is very hard. I can make
                    your life so easy with my development skill.
                  </p>
                </Col>
                <Col>
                  <img className="img-fluid" src={serivce2} alt="" />
                </Col>
              </Row>
            </Card>
          </Col>
          <Col data-aos="fade-up">
            <Card className="service-card service-3">
              <Row xs={1} md={2}>
                <Col>
                  <h3>Portfolio website</h3>
                  <p>
                    Portfolio website should reflect your creativity. I can work
                    on that with your preference.
                  </p>
                </Col>
                <Col>
                  <img className="img-fluid" src={serivce3} alt="" />
                </Col>
              </Row>
            </Card>
          </Col>
          <Col data-aos="fade-up">
            <Card className="service-card service-4">
              <Row xs={1} md={2}>
                <Col>
                  <h3>Informative website</h3>
                  <p>
                    I will make a nice and Informative website for you. That
                    website can be the best site of its catagory.
                  </p>
                </Col>
                <Col>
                  <img className="img-fluid" src={serivce1} alt="" />
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default ServiceSection;
